<vb-ui-toggle-content-display [minItems]="10" [totalItems]="categories.length" class="col-sm">
	<div layout="row">
		<div [ngClass]="styles.item" *ngFor="let category of categories" #vbUiToggleItem>
			<a *ngIf="isGuestPortalEnabled" [uiSref]="PORTAL_MEDIA_CATEGORY_DETAILS_STATE" [uiParams]="{categoryId: category.categoryId}">
				{{ category.fullPath }}
			</a>
			<span *ngIf="!isGuestPortalEnabled">{{ category.fullPath }}</span>
		</div>
	</div>
</vb-ui-toggle-content-display>
